import { supabase } from '../lib/supabaseClient';
import type { DemandUnit, PlannedDemandRecord } from '../components/ops/plannedDemand';

interface PlannedDemandRow {
  id: string;
  organization_id: string;
  department_id: string | null;
  value: number;
  unit: string;
  standard_minutes_per_task: number | null;
  valid_from: string;
  valid_to: string | null;
  active: boolean;
}

function mapRow(row: PlannedDemandRow): PlannedDemandRecord {
  return {
    id: row.id,
    organizationId: row.organization_id,
    departmentId: row.department_id,
    value: Number(row.value),
    unit: row.unit === 'tasks_per_hour' ? 'tasks_per_hour' : 'tasks_per_hour',
    standardMinutesPerTask: row.standard_minutes_per_task,
    validFrom: row.valid_from,
    validTo: row.valid_to,
    active: row.active,
  };
}

const COLUMNS = 'id, organization_id, department_id, value, unit, standard_minutes_per_task, valid_from, valid_to, active';

export async function listPlannedDemand(organizationId: string): Promise<PlannedDemandRecord[]> {
  const { data, error } = await supabase
    .from('planned_demand')
    .select(COLUMNS)
    .eq('organization_id', organizationId)
    .order('valid_from', { ascending: false });
  if (error) throw error;
  return (data ?? []).map((row) => mapRow(row as PlannedDemandRow));
}

export async function createPlannedDemand(input: {
  organizationId: string;
  departmentId: string | null;
  value: number;
  unit: DemandUnit;
  validFrom: string;
  validTo: string | null;
}): Promise<void> {
  const { data: auth } = await supabase.auth.getUser();
  const { error } = await supabase.from('planned_demand').insert({
    organization_id: input.organizationId,
    department_id: input.departmentId,
    value: input.value,
    unit: input.unit,
    valid_from: input.validFrom,
    valid_to: input.validTo,
    active: true,
    created_by: auth.user?.id ?? null,
    standard_minutes_per_task: null,
  });
  if (error) throw error;
}

export async function deactivatePlannedDemand(id: string): Promise<void> {
  const { error } = await supabase
    .from('planned_demand')
    .update({ active: false, updated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}
